import * as React from "react";
import {getTranslation} from "../../utils/translationUtil";

export const homeHeaderDescription = "Your gateway to advanced, data-driven investment insights";
export const homeHeaderTitle = "Insights Delivered";
export const HomeHeader: React.FunctionComponent = () => {
    return <div>
        <div className="home-header__container" data-testid="home-header__container">
            <div className="home-header__title">{getTranslation("home.header-title", homeHeaderTitle)}</div>
            <div className="home-header__description">
                {getTranslation("home.header-description", homeHeaderDescription)}
            </div>
        </div>
        <div className="home-top-spacer" data-testid="home-top-spacer"/>
    </div>;
};